// @flow
import type {Element} from 'react'
import React, {useCallback} from 'react'

import List from 'components/ui/icons/md/List'
import Create from 'components/ui/icons/md/Create'
import Close from 'components/ui/icons/md/Close'
import IconButton from 'components/ui/Inputs/IconButton'

type Props = {
  onClickDelete: ?(() => void),
  isSummaryShown: boolean,
  showSummary: () => void,
  hideSummary: () => void,
}

function Toolbar({onClickDelete, isSummaryShown, showSummary, hideSummary}: Props): Element<"div"> {
  const onDelete = useCallback(() => {
    if (!onClickDelete)
      return

    // eslint-disable-next-line no-alert
    if (!window.confirm(I18n.t('proposals.react.remove_proposal_part')))
      return

    onClickDelete()
  }, [onClickDelete])

  return (
    <div className="refinery-toolbar">
      <div className="refinery-toolbar__summary-toggle">
        <div className="refinery-toolbar__left-button">
          <IconButton
            faded={!isSummaryShown}
            highlighted={isSummaryShown}
            title={I18n.t('shared.view')}
            tabIndex="-1"
            onClick={showSummary}
          >
            <List />
          </IconButton>
        </div>
        <div
          className="refinery-toolbar__right-button refinery-toolbar__small_icon"
        >
          <IconButton
            faded={isSummaryShown}
            highlighted={!isSummaryShown}
            title={I18n.t('shared.edit')}
            onClick={hideSummary}
          >
            <Create />
          </IconButton>
        </div>
      </div>
      {onClickDelete && (
        <div className="refinery-toolbar__delete-button js-remove-part">
          <IconButton
            highlighted
            onClick={onDelete}
            title={I18n.t('shared.delete')}
          >
            <Close />
          </IconButton>
        </div>
      )}
    </div>
  )
}

Toolbar.defaultProps = {
  onClickDelete: null,
}

export default Toolbar
